// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import request from './request'

/**
 * @description 商户权限管理 -- 列表
 */
export function teamMenuListApi(data) {
  return request.get('team/menu/lst', data)
}
/**
 * @description 商户权限管理 -- 新增表单
 */
export function teamMenuCreateApi() {
  return request.get('team/menu/create/form')
}
/**
 * @description 商户权限管理 -- 编辑表单
 */
export function teamMenuUpdateApi(id) {
  return request.get(`team/menu/update/form/${id}`)
}
/**
 * @description 商户权限管理 -- 删除
 */
export function teamMenuDeleteApi(id) {
  return request.delete(`team/menu/delete/${id}`)
}

/**
 * @description 团队列表 ---头部
 */
export function teamChartListApi() {
  return request.get(`team/chart/list`)
}

/**
* @description 团队列表 ---列表
*/
export function teamListApi(data) {
  return request.get(`team/lst`, data)
}

/**
 * 编辑状态
 */
export function teamStatusUpdateApi(id) {
  return request.get(`team/status/update/form/${id}`)
}

/**
 * @description 对账订单 -- 发起对账单
 */
export function teamLoginApi(team_id) {
  return request.post(`team/login/${team_id}`)
}
